module.exports = __webpack_public_path__ + "img/web-color.70938d73.png";